import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import TreeList from 'shared/components/Tree/TreeList';
import { unflattenEntities, updateTreeData } from 'shared/components/Tree/treeUtils';
import { routeGenerator } from 'routes';

import s from './NotificationSidebar.pcss';


const setIndentTree = tree =>
  tree.map(node => ({ ...node, indent: node.weightIndex * 20 }));

@withRouter
export default class NotificationSidebar extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    history: PropTypes.shape().isRequired,
    match: PropTypes.shape().isRequired,
    location: PropTypes.shape().isRequired,
  };


  state = {
    treeData: this.props.data,
  };

  componentDidMount() {
    this.setState({ treeData: this.props.data }, () => this.expandTree(this.props));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.length !== nextProps.data.length) {
      this.setState({ treeData: nextProps.data });
    }
  }

  expandTree = (props) => {
    const { treeData } = this.state;
    const expandedId = props.match.params.sectionId || null;
    const updatedData = updateTreeData(treeData, expandedId, 'parentSectionId');
    this.setState({ treeData: updatedData });
  };

  onExpandTree = (node) => {
    const sectionId = node.id;
    const { treeData } = this.state;
    const { history, location: { search = '' }, match } = this.props;

    const searchUpdated = new URLSearchParams(search);
    searchUpdated.delete('search');

    const linkId = match.params.sectionId === sectionId
      ? (node.parentSectionId === 'null' ? '' : node.parentSectionId)
      : sectionId;
    history.push({
      pathname: routeGenerator.notificationEditLink(linkId),
      search: searchUpdated.toString(),
    });
    const updatedData = updateTreeData(treeData, sectionId, 'parentSectionId');
    this.setState({ treeData: updatedData }, () => this.expandTree(this.props));
  };

  render() {
    const { treeData } = this.state;
    const sortedData = treeData.sort((a, b) => a.order - b.order);
    const expandedKeys = sortedData.filter(item => item.isExpanded).map(item => item.id);
    const indentedTree = setIndentTree(sortedData);
    const tree = unflattenEntities(indentedTree, 'id', 'parentSectionId');

    return (
      <div className={s.sidebar}>
        <div className={s.sidebarLabel}>Дерево разделов</div>
        <div className={s.treeContainer}>
          <TreeList
            tree={tree}
            expandedKeys={expandedKeys}
            onExpand={this.onExpandTree}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Notifications/Sidebar/NotificationSidebar.js